export const Status = {
    IDLE: 'idle',
    SUCCESS: 'succeeded',
    FAIL: 'failed',
    LOADING: 'loading'
}